<script lang="ts">
	import { handleInvalidInputs } from "./handleInvalidInputs.js";

	export let form: HTMLFormElement | null = null;
	export let id = "";
	export let antiSpamInputName: string | undefined = "comment";
	export let onsubmit: ((event: SubmitEvent) => void) | undefined = undefined;

	let formClass = "";
	export { formClass as class };

	const expected = "2Y0R3BnkK9U3NE7GCuWzhk4yNsDVjTG2WQe";
	function handleAntispamSubmit(event: SubmitEvent): void {
		event.preventDefault();

		if (!antiSpamInputName) {
			onsubmit?.(event);
			return;
		}
		if (!(event.currentTarget instanceof HTMLFormElement)) {
			return;
		}
		const data = new FormData(event.currentTarget);
		const antiSpam = data.get(antiSpamInputName);
		if (antiSpam !== expected) {
			return;
		}
		onsubmit?.(event);
	}
</script>

<form
	bind:this={form}
	class={formClass}
	{id}
	on:submit={handleAntispamSubmit}
	use:handleInvalidInputs
	on:change
	on:input
>
	<slot />

	{#if antiSpamInputName}
		<input type="text" name={antiSpamInputName} id={antiSpamInputName} class="hidden" value={expected} required />
	{/if}
</form>
